import { ProtectedRouteConstants } from '../navigation/navigation-types'
import { supabase } from '../lib/supabase'
import { setUser } from '../storages/user'

export const loginUser = async (email: string, password: string) => {
    const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password,
    })

    if (error || !data.user) {
        alert('Login failed')
        return
    }

    setUser({
        uuid: data.user.id,
        name: data.user.user_metadata?.name ?? 'admin',
        email: data.user.email ?? email,
        phone: data.user.phone ?? '',
    })

    window.location.href = '#' + ProtectedRouteConstants.form
}
